module.exports = __webpack_public_path__ + "static/media/ARPackingInBag.00931bd6.png";